import React, { Component } from 'react';
import Communication from '../utils/Communication';
import UI from '../ui';
import Utils from '../utils';

const { WrappedButton, WrappedInputTextWithLabel } = UI;
const { Logger, Session, Util } = Utils;

const errorMessageEnum = Object.freeze({
	InvalidVerificationCode: 4525576,
	// VerificationCodeExpired: 4525577, may come back to re-enable this
	ThreeAttemptsFailed: 4525570,
});

class EnterVerificationCode extends Component {
	constructor(props) {
		super(props);

		this.state = {
			verificationCode: '',
			finishVerificationCodeErrorMessage: '',
			isLoading: false,
		};

		Logger.logToServer({
			verificationStep: 'step2',
			action: 'View',
		});
	}

	handleVerificationCodeChange = e => {
		this.setState({
			verificationCode: e.target.value,
			finishVerificationCodeErrorMessage: '',
		});
	};

	handleResendCodeClick = e => {
		const {
			nextStep,
			isChangingEmailAddress,
			emailOnly,
			startAccountVerification,
		} = this.props;

		e.preventDefault();

		if (isChangingEmailAddress || emailOnly) {
			// resend verification code
			startAccountVerification('email');
		} else {
			// go back to step 1
			nextStep('1');
		}

		Logger.logToServer({
			verificationStep: 'step2',
			button: 'resendCode',
		});
	};

	handleSubmitClick = () => {
		this.setState(
			{
				isLoading: true,
			},
			this.finishVerificationCode
		);
	};

	finishVerificationCode = async () => {
		const { verificationCode } = this.state;
		const { nextStep } = this.props;
		const brand = Session.getBrand();

		Logger.saveActionData('Send Verification Code Button Clicked');

		const response = await Communication.finishAccountVerification({
			AccountVerificationCode: verificationCode,
		});

		if (Communication.isSuccessful(response)) {
			// reload Session account info to update accountStatus
			Session.loadAccountInfo();

			// go to next step
			nextStep('3');
		} else {
			let errorMessage = '';

			switch (response.ErrorCode) {
				case errorMessageEnum.InvalidVerificationCode:
					errorMessage =
						'The verification code you have provided is invalid. Please try again.';
					break;
				// case errorMessageEnum.VerificationCodeExpired:
				// 	errorMessage =
				// 		'The verification code you have provided has expired. Please request a new code and try again.';
				// 	break;
				case errorMessageEnum.ThreeAttemptsFailed:
					errorMessage = `You have failed to verify your identity. To restore access to your account, contact support at ${Util.getFraudNumber(
						brand
					)} between 6 a.m and 6 p.m. Central Time.`;
					break;
				default:
					errorMessage = 'An error occurred. Please try again.';
					break;
			}

			this.setState({
				finishVerificationCodeErrorMessage: errorMessage,
			});
		}

		this.setState({
			isLoading: false,
		});

		Logger.logToServer({
			verificationStep: 'step2',
			button: 'submit',
			error: response.ErrorDescription || '',
		});
	};

	render() {
		const { verificationCode, finishVerificationCodeErrorMessage, isLoading } = this.state;
		const {
			phoneNumber,
			email,
			isMobile,
			isChangingEmailAddress,
			startAccountVerificationError,
			displayEmailTextInEnterVerification,
		} = this.props;
		const displayErrorMessage =
			startAccountVerificationError || finishVerificationCodeErrorMessage;

		// not destructuring the brand object because getFraudNumber needs entire brand object
		const brand = Session.getBrand();

		const phoneInstructions = `At ${brand.brandName}, we take your security seriously. To continue, please enter the verification code we've sent to ${Util.maskPhoneNumber(
			phoneNumber
		)}. If you need assistance, please contact us by phone at ${Util.getFraudNumber(
			brand
		)}, Monday through Friday, 8am to 8pm CT.`;

		return (
			<div className="common-account-verification-enter-verification">
				<p>
					{isChangingEmailAddress || displayEmailTextInEnterVerification
						? `At ${brand.brandName}, we take your security seriously. To continue, please enter the verification code we've sent to ${Util.maskEmail(
								email
						  )}. If you have not received your verification code, try checking your junk/spam folder. If you need assistance, please contact us by phone at ${Util.getFraudNumber(
								brand
						  )}, Monday through Friday, 8am to 8pm CT.`
						: phoneInstructions}
				</p>
				<div className="input-group verify-input-container">
					<WrappedInputTextWithLabel
						className={`enter-code-input ${isMobile ? 'mobile-wrapper' : ''}`}
						uiElementConfig={{
							placeholder: 'Enter Code',
							type: 'text',
							name: 'verificationCode',
							value: verificationCode,
							onChange: this.handleVerificationCodeChange,
							dataqa: 'enter-verification-code-input',
							autoFocus: true,
						}}
					/>
				</div>
				{displayErrorMessage && (
					<div>
						<span className="error-icon" />
						<span className="error-message">
							{startAccountVerificationError &&
							finishVerificationCodeErrorMessage === ''
								? startAccountVerificationError
								: finishVerificationCodeErrorMessage}
						</span>
					</div>
				)}
				<div className="action-bar">
					<WrappedButton
						label="Submit"
						onClick={this.handleSubmitClick}
						buttonType="primary"
						disabled={!verificationCode || isLoading}
						dataqa="enter-verification-code-button"
					/>
					<WrappedButton
						label="Resend Code"
						buttonType="secondary"
						onClick={this.handleResendCodeClick}
						dataqa="resubmit-verification-code-button"
					/>
				</div>
			</div>
		);
	}
}

export default EnterVerificationCode;
